import { GroupModel } from "./GroupModel";
import { Organisation } from "./Organisation";

export class Suppliers {
    mill: Organisation
    groups: GroupModel[]

    constructor(d: any) {
        this.mill = Organisation.build(d.mill)
        this.groups = d.groups
    }

    static build(d: any): Suppliers {
        return new Suppliers(d)
    }
}